// extracted by mini-css-extract-plugin
export default {"root":"styles_root__w4jgB","placeholderWrap":"styles_placeholderWrap__1ueX4","textNoData":"styles_textNoData__mf051"};